import { Box, Button, Typography } from '@mui/material'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { convertOrderStatusEnumToStatusCode } from '../../../utils/convertOrderStatusValue'
import { OrderStatusEnum } from '../../../enums/orderStatus'
import { OrderModel } from '../../../models/order'

interface Props {
    selectedData: OrderModel
    onOpenDeclineConfirmDialog: () => void
    onOpenConfirmDialog: (getIsDeclineOrder: boolean) => void
    onOpenIsPacking: () => void
}

const ActionButton = ({ onOpenDeclineConfirmDialog, selectedData, onOpenConfirmDialog, onOpenIsPacking }: Props) => {
    const { t } = useTranslation('global')
    return (
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'column',
                mt: 1,
                p: 2,
                background: "var(--background-light-paper, #FFF)",
                boxShadow: "0px 12px 24px -4px rgba(145, 158, 171, 0.12), 0px 0px 2px 0px rgba(145, 158, 171, 0.20)",
                borderRadius: '12px'
            }}
        >
            <Typography
                sx={{
                    color: "#616161",
                    fontSize: '18px',
                    mb: 2,
                    textAlign: 'center'
                }}
            >
                {t("order_page.Would you accept this order?")}
            </Typography>

            <Box
                sx={{
                    display: 'flex',
                    gap: 2,
                    flexWrap: 'wrap',
                    justifyContent: 'center'
                }}
            >
                <Button
                    onClick={() => onOpenDeclineConfirmDialog()}
                    variant="outlined"
                    color="error"
                    sx={{
                        textTransform: 'none',
                        width: "100px",
                        color: '#fe0000'
                    }}
                >
                    {t("order_page.Decline")}
                </Button>

                {selectedData?.status?.code === convertOrderStatusEnumToStatusCode(OrderStatusEnum.CURRENT_ORDER) && (
                    <Button
                        onClick={() => onOpenConfirmDialog(false)}
                        variant="contained"
                        color="secondary"
                        sx={{
                            textTransform: 'none',
                            width: "100px",
                            color: 'white'
                        }}
                    >
                        {t("order_page.To pack")}
                    </Button>
                )}

                <Button
                    onClick={onOpenIsPacking}
                    variant="contained"
                    color="primary"
                    sx={{
                        textTransform: 'none',
                        width: "100px",
                        color: 'white'
                    }}
                >
                    {t("order_page.Pack now")}
                </Button>
            </Box>
        </Box>
    )
}

export default ActionButton